/* eslint-disable no-param-reassign */
import axios from 'axios';
import { base } from '../../config/config';

class PeopleResult {
  constructor(people, pages, totalRes, query) {
    this.people = people;
    this.pages = pages;
    this.totalRes = totalRes;
    this.query = query;
  }
}

export default {
  state: {
    searchData: {
      people: [],
      pages: '',
      totalRes: '',
      query: '',
      page: null,
    },
  },
  mutations: {
    setPeople(state, payload) {
      payload.people.forEach((element) => {
        state.searchData.people.push(element);
      });
      state.searchData.pages = payload.pages;
      state.searchData.totalRes = payload.totalRes;
      state.searchData.query = payload.query;
      state.searchData.page += 1;
    },
    clearPeople(state) {
      state.searchData.people = [];
      state.searchData.pages = '';
      state.searchData.totalRes = '';
      state.searchData.query = '';
      state.searchData.page = null;
    },
  },
  actions: {
    async getPopularPeople({ commit }, { page = 1 }) {
      commit('clearError');
      commit('setLoading', true);

      try {
        const url = `${base.urlPrefix}/person/popular?api_key=${base.key}&${
          base.language
        }&page=${page}`;

        const response = await axios.get(url);
        const { data } = response;
        const result = new PeopleResult(
          data.results,
          data.total_pages,
          data.total_results,
          null,
        );

        // console.log(result);

        commit('setLoading', false);
        commit('setPeople', result);
      } catch (error) {
        commit('setError', `Uups! Da is was schief gelaufen: ${error.message}`);
        commit('setLoading', false);
      }
    },
  },
  getters: {
    getTotalPeople(state) {
      return state.searchData.totalRes;
    },
  },
};
